import axios from 'axios';

const api = axios.create({
  // baseURL: 'http://localhost:3333',
	// baseURL: 'http://192.168.100.150:3333', // Casa
  // baseURL: 'http://192.168.0.29:3333', // Escritório
	// baseURL: 'https://raziobackend.razio.com.br', // Servidor //
	baseURL: 'https://api.razio.com.br'
});

export default api;
